/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterCardDTO
 */
export interface RegisterCardDTO {
    /**
     * 
     * @type {string}
     * @memberof RegisterCardDTO
     */
    cardId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCardDTO
     */
    cardTypeId?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterCardDTO
     */
    carePrincipalId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RegisterCardDTO
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterCardDTO
     */
    extendExisting?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterCardDTO
     */
    personId?: string;
    /**
     * 
     * @type {Date}
     * @memberof RegisterCardDTO
     */
    preliminaryCardDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof RegisterCardDTO
     */
    registrationReason?: string;
}

export function RegisterCardDTOFromJSON(json: any): RegisterCardDTO {
    return RegisterCardDTOFromJSONTyped(json, false);
}

export function RegisterCardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterCardDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'cardId': !exists(json, 'cardId') ? undefined : json['cardId'],
        'cardTypeId': !exists(json, 'cardTypeId') ? undefined : json['cardTypeId'],
        'carePrincipalId': !exists(json, 'carePrincipalId') ? undefined : json['carePrincipalId'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'extendExisting': !exists(json, 'extendExisting') ? undefined : json['extendExisting'],
        'personId': !exists(json, 'personId') ? undefined : json['personId'],
        'preliminaryCardDate': !exists(json, 'preliminaryCardDate') ? undefined : (new Date(json['preliminaryCardDate'])),
        'registrationReason': !exists(json, 'registrationReason') ? undefined : json['registrationReason'],
    };
}

export function RegisterCardDTOToJSON(value?: RegisterCardDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'cardId': value.cardId,
        'cardTypeId': value.cardTypeId,
        'carePrincipalId': value.carePrincipalId,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString().substr(0,10)),
        'extendExisting': value.extendExisting,
        'personId': value.personId,
        'preliminaryCardDate': value.preliminaryCardDate === undefined ? undefined : (value.preliminaryCardDate.toISOString().substr(0,10)),
        'registrationReason': value.registrationReason,
    };
}

